module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-SolutionStatusTest-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('solutionStatusTestDialogTitle')) + "\n  "), _c('p', {
    class: _vm.description.class
  }, [_vm._v("\n    " + _vm._s(_vm.$t(_vm.description.text)) + "\n    "), _c('u', [_c('a', {
    attrs: {
      "href": _vm.support.href,
      "target": _vm.support.target
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.support.text)))])]), _vm._v(".\n  ")])]), _vm._v(" "), _c('el-form', {
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "testform",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.triggerTest($event)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('account') ? _vm.$t('solutionStatusTestInputAccountError') : '',
      "label": _vm.$t('solutionStatusTestInputAccountLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('account'),
      "data-qa": "Dialog-SolutionStatusTestAccount-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true} }"
    }],
    attrs: {
      "disabled": true,
      "data-qa": "Dialog-SolutionStatusTestAccount-Input",
      "name": "account",
      "required": "",
      "type": "email"
    },
    model: {
      value: (_vm.data.SolutionAccount),
      callback: function($$v) {
        _vm.$set(_vm.data, "SolutionAccount", $$v)
      },
      expression: "data.SolutionAccount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('password') ? _vm.$t('solutionStatusTestInputPasswordError') : '',
      "label": _vm.$t('solutionStatusTestInputPasswordLabel'),
      "label-width": _vm.labelWidth,
      "show-message": _vm.errors.has('password'),
      "data-qa": "Dialog-SolutionStatusTestPassword-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true} }"
    }],
    attrs: {
      "clearable": "",
      "data-qa": "Dialog-SolutionStatusTestPassword-Input",
      "name": "password",
      "required": "",
      "type": "password"
    },
    model: {
      value: (_vm.data.SolutionPassword),
      callback: function($$v) {
        _vm.$set(_vm.data, "SolutionPassword", $$v)
      },
      expression: "data.SolutionPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "error": _vm.errors.has('recipients') ? 'error' : '',
      "label": _vm.$t(_vm.recipients.label),
      "label-width": _vm.labelWidth,
      "show-message": false,
      "data-qa": "Dialog-SolutionStatusTestRecipients-Item"
    }
  }, [_c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|emails'),
      expression: "'required|emails'"
    }],
    attrs: {
      "clearable": "",
      "autosize": {
        minRows: 3
      },
      "data-vv-as": _vm.$t(_vm.recipients.label),
      "name": "recipients",
      "required": "",
      "placeholder": "example1@email.com,example2@email.com",
      "type": "textarea"
    },
    model: {
      value: (_vm.data.RecipientList),
      callback: function($$v) {
        _vm.$set(_vm.data, "RecipientList", $$v)
      },
      expression: "data.RecipientList"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('recipients')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(_vm.recipients.tips)))])], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-SolutionStatusTest-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('solutionStatusTestDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-SolutionStatusTest-Button-Save",
      "type": "warning"
    },
    on: {
      "click": _vm.triggerTest
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('solutionStatusTestDialogButtonOKText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d7c9512c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SolutionStatusTest/SolutionStatusTest.vue
// module id = 984
// module chunks = 3